import { Component } from "react"
import PropTypes from "prop-types"
import FeedbackContainer from "partners/components/review/feedback_container"

export default class ServiceTests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      review: this.props.review,
      feedback: this.props.feedback,
      endpointFeedback:
        this.props.feedback.channel &&
        this.props.feedback.channel.endpoint_test,
      activationFeedback:
        this.props.feedback.channel &&
        this.props.feedback.channel.activation_test,
      progressFeedback:
        this.props.feedback.channel &&
        this.props.feedback.channel.progress_checklist,
    }

    this.onFeedbackUpdated = this.props.onFeedbackUpdated
  }

  componentDidUpdate() {
    if (
      (!!this.state.endpointFeedback ||
        !!this.state.activationFeedback ||
        !!this.state.progressFeedback) &&
      !this.props.submenuIcons.testsFeedback
    ) {
      this.props.setSessionFeedback(
        "tests",
        JSON.parse(window.sessionStorage.submenuIcons)
      )
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      endpointFeedback:
        nextProps.feedback.channel && nextProps.feedback.channel.endpoint_test,
      activationFeedback:
        nextProps.feedback.channel &&
        nextProps.feedback.channel.activation_test,
      progressFeedback:
        nextProps.feedback.channel &&
        nextProps.feedback.channel.progress_checklist,
    })
  }

  render() {
    const endpointsPassing =
      this.state.review &&
      this.state.review.most_recent_endpoint_test_result &&
      !this.state.review.most_recent_endpoint_test_result.failed
    const endpointsLastRun =
      this.state.review &&
      this.state.review.most_recent_endpoint_test_result &&
      this.state.review.most_recent_endpoint_test_result.timestamp
        ? new Date(
            this.state.review.most_recent_endpoint_test_result.timestamp
          ).toString()
        : ""
    return (
      <section className="review-section tests">
        <a id="tests" />
        <h2>Tests</h2>
        <table>
          <tbody>
            <tr>
              <th>Endpoint tests</th>
              <td>
                <a
                  href={this.props.endpointTestUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={endpointsPassing ? "passing" : "failing"}
                >
                  {endpointsPassing ? "Passing" : "Failing"}
                </a>
                {endpointsLastRun ? <div className="last-run-at">Last run: {endpointsLastRun}</div> : null}
              </td>
              <td className="feedback">
                <FeedbackContainer
                  feedbackItems={this.state.endpointFeedback}
                  fieldName="Endpoint Test"
                  service={this.props.service}
                  pathObjs={["channel", "endpoint_test"]}
                  onFeedbackUpdated={this.onFeedbackUpdated}
                />
              </td>
            </tr>
            {this.props.service.authentication_type === "auth_not_required" ? null : (
              <tr>
                <th>Authentication test</th>
                <td>
                  <a
                    href={this.props.authenticationTestUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="open-in-new"
                  >
                    View authentication test
                  </a>
                </td>
                <td className="feedback">
                  <FeedbackContainer
                    feedbackItems={this.state.activationFeedback}
                    fieldName="Authentication test"
                    service={this.props.service}
                    pathObjs={["channel", "activation_test"]}
                    onFeedbackUpdated={this.onFeedbackUpdated}
                  />
                </td>
              </tr>
            )}
            <tr>
              <th>Progress checklist</th>
              <td>
                <a
                  href={this.props.progressChecklistUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={this.props.review.progress.passing ? "passing" : "failing"}
                >
                  {this.props.review.progress.passing ? "Passing" : "Failing"}
                </a>
              </td>
              <td className="feedback">
                <FeedbackContainer
                  feedbackItems={this.state.progressFeedback}
                  fieldName="Progress Checklist"
                  service={this.props.service}
                  pathObjs={["channel", "progress_checklist"]}
                  onFeedbackUpdated={this.onFeedbackUpdated}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    )
  }
}

ServiceTests.propTypes = {
  authenticationTestUrl: PropTypes.string.isRequired,
  endpointTestUrl: PropTypes.string.isRequired,
  feedback: PropTypes.object,
  onFeedbackUpdated: PropTypes.func,
  progressChecklistUrl: PropTypes.string.isRequired,
  review: PropTypes.object,
  service: PropTypes.object,
}
